module.exports = __webpack_public_path__ + "img/howto-en.8b82ede9.svg";